import { Component } from "@angular/core";
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from "ag-grid-community";
import { Router } from "@angular/router"; 
import { NgxUiLoaderService } from "ngx-ui-loader";
import Swal from 'sweetalert2';
import { AppCoreService } from 'src/app/services/app-core.service'; 
import { Title } from "@angular/platform-browser";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { ReportService } from "src/app/services/report/report.service";
import { EditShareDeleteActionsRenderer } from "src/app/components/shared/ag-grid/cell-renderers/edit-share-delete.component";
import { ShareComponent } from "../share/share.component";


@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListCustomReportComponent {

  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public context: any;
  loginType: string;
  userData: any;
  public isCustomer = false;
  defaultColDef = {
    sortable: true,
    resizable: false,
  };
  gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 10,
    domLayout: 'autoHeight',
  }

  columnDefs = [
    { headerName: 'Type', field: 'reporttype', filter: true },
    { headerName: 'Name', field: 'reportname', filter: true },
    { headerName: 'Created By', field: 'createdby', filter: true },
    {
      headerName: 'Actions',
      field: 'id',
      cellRenderer: EditShareDeleteActionsRenderer,
      cellClass: "actions-button-cell",
      cellStyle: { "overflow": 'visible' },
      colId: 'params',
      editable: false,
      sortable: false,
      minWidth: 150,
    },
  ];

  rowData: any[] = [];

  constructor(
    private router: Router,
    private ngxLoaderService: NgxUiLoaderService,
    private appCoreService: AppCoreService,
    public modalService: NgbModal,
    public reportService: ReportService,
    private titleService: Title
  ) {
    titleService.setTitle('Custom Report');
    this.context = { componentParent: this };
  }

  ngOnInit() {
    this.checkPermission();
    if (this.permConfig.isViewAllowed) {
      this.bindCustomReportList();
    }
  }

  checkPermission(): any {
    this.userData = this.appCoreService.GetUserData();
    const permission = this.userData.config.filter(x => x.categoryname === 'CustomReports');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  bindCustomReportList() {
    const userId = this.userData.userId;
    try {
      this.ngxLoaderService.start();
      // this.reportService.getAllCustomReportByUserId(userId).subscribe(res => {
      //   if (res && res.success) {
      //     this.ngxLoaderService.stop();
      //     this.rowData = res.data;
      //   } else {
      //     this.ngxLoaderService.stop();
      //   }
      // });
    } catch (e) {
      console.error(e);
      this.ngxLoaderService.stop();
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setDomLayout("autoHeight");
    params.api.sizeColumnsToFit();
  }

  editAction(cell: any) {
    try {
      if (!this.permConfig.isEditAllowed) {
        this.warningDialog('No access to Edit.');
      }
      else if (this.permConfig.isEditAllowed && cell && cell.id) {
        this.router.navigate(['/reports/customreports/edit', cell.id]);
      }
    } catch (e) {
      console.error(e);
    }
  }

  shareAction(cell: any) {
    if (!this.permConfig.isEditAllowed) {
      this.warningDialog('No access to Share.');
    }
    else if (this.permConfig.isEditAllowed && cell && cell.id) {
      let ngbModalOptions : NgbModalOptions = {
        ariaLabelledBy :'modal-basic-title',
        size : 'md',
        backdrop: 'static',
        keyboard: false,
        centered: true
      };
      const modalRef = this.modalService.open(ShareComponent,ngbModalOptions);
      modalRef.componentInstance.customReportId = cell.id;
      modalRef.result.then(
        (result) => {
          if (result) {
          
          }
        }
      );
    }
  }

  deleteAction(cell: any) {
    if (!this.permConfig.isDeleteAllowed) {
      this.warningDialog('No access to Delete.');
    }
    else if (this.permConfig.isDeleteAllowed && cell && cell.id) {
      this.openConfirmationDialog('Are you sure you want to delete ?', cell.id);
    }
  }

  deleteRecord(id) {
    try {
      if (id) {
        this.ngxLoaderService.start();
        // this.reportService.deleteCustomReport(id).subscribe((res) => {
        //   if (res && res.success) {
        //     this.ngxLoaderService.stop();
        //     this.bindCustomReportList();
        //     this.appCoreService.showMessage('Record deleted successfuly', 'Success', 'success');
        //   }
        // });
      }
    } catch (e) {
      this.ngxLoaderService.stop();
      console.error(e);
    }
  }

  async openConfirmationDialog(msg: any, id?: number) {
    const result = await Swal.fire({
      titleText: 'Confirmation',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (result.isConfirmed) {
      this.deleteRecord(id);
    }
  }

  warningDialog(msg: any) {
    Swal.fire({
      title: 'Warning!',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
  }



}
